export default __webpack_public_path__ + "static/media/signal_info.8036a65c.svg";